import React, { useState } from "react";
import { Helmet } from 'react-helmet-async';
import UserSidebar from "@/components/UserSidebar";
import CardRegistrationDialog from "@/components/CardRegistrationDialog";
import PaymentMethodList from "@/components/PaymentMethodList";
import { CreditCard } from "lucide-react";

interface PaymentMethodsPageProps {
  siteData?: {
    payment_provider?: 'fincode' | 'gmo_pg';
    gmo_pg_shop_id?: string;
    test_mode?: boolean;
  };
}

const KujiPaymentMethodsPage: React.FC<PaymentMethodsPageProps> = ({ siteData }) => {
  const [showCardRegistrationDialog, setShowCardRegistrationDialog] = useState<boolean>(false);
  const [paymentMethodsRefresh, setPaymentMethodsRefresh] = useState(0);

  return (
    <>
      <Helmet>
        <title>お支払い方法</title>
        <meta property="og:title" content="お支払い方法" />
      </Helmet>

      <div className="min-h-screen bg-theme-bg">
        <div>
          <div className="max-w-screen-lg mx-auto px-4 pb-4 sm:pb-8 pt-20">
            <div className="flex gap-8">
              {/* サイドバー - デスクトップのみ */}
              <div className="hidden lg:block">
                <UserSidebar />
              </div>

              {/* メインコンテンツ */}
              <section className="flex-1 min-w-0">
                {/* タイトルセクション */}
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 bg-theme-primary border-theme rounded-theme flex items-center justify-center shadow-theme-sm">
                    <CreditCard className="h-5 w-5 text-theme-button" />
                  </div>
                  <div>
                    <h1 className="text-xl [font-weight:var(--theme-font-weight)] text-theme-bg-text">お支払い方法</h1>
                    <p className="text-sm [font-weight:var(--theme-font-weight-button)] text-theme-bg-text opacity-70">クレジットカードの登録・管理ができます</p>
                  </div>
                </div>

                {/* コンテンツカード */}
                <div className="p-4 sm:p-6 bg-white border-theme rounded-theme-lg shadow-theme">
                  {/* 登録カード */}
                  <div>
                    <div className="flex items-center gap-2 mb-3">
                      <div className="w-8 h-8 bg-theme-primary border-theme rounded-theme flex items-center justify-center">
                        <CreditCard className="h-4 w-4 text-theme-button" />
                      </div>
                      <h3 className="text-sm [font-weight:var(--theme-font-weight-button)] text-black">登録済みカード</h3>
                    </div>
                    <PaymentMethodList
                      onAddCard={() => setShowCardRegistrationDialog(true)}
                      refreshTrigger={paymentMethodsRefresh}
                    />
                  </div>

                  {/* 注意事項 */}
                  <div className="mt-6 p-4 border-theme rounded-theme bg-gray-50">
                    <h4 className="text-sm [font-weight:var(--theme-font-weight)] text-black mb-2">ご利用について</h4>
                    <ul className="text-sm [font-weight:var(--theme-font-weight-button)] text-gray-600 space-y-1">
                      <li>・カード情報は安全に暗号化されて保存されます</li>
                      <li>・登録したカードはくじ購入時にご利用いただけます</li>
                      <li>・カードの削除は登録済みカード一覧から行えます</li>
                    </ul>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      {/* カード登録モーダル */}
      <CardRegistrationDialog
        isOpen={showCardRegistrationDialog}
        onClose={() => setShowCardRegistrationDialog(false)}
        onSuccess={() => setPaymentMethodsRefresh(prev => prev + 1)}
        paymentProvider={siteData?.payment_provider}
        gmoPgShopId={siteData?.gmo_pg_shop_id}
        testMode={siteData?.test_mode}
      />
    </>
  );
};

export default KujiPaymentMethodsPage;
